import React, { useLayoutEffect } from 'react';
import { NavLink, Link, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { TopMenuStyle } from './style';
// import 

const TopMenu = () => {
  const { path } = useRouteMatch();

  useLayoutEffect(() => {
    const active = document.querySelector('.strikingDash-top-menu a.active');
    const activeDefault = () => {
      const megaMenu = active.closest('.megaMenu-wrapper');
      const hasSubMenuLeft = active.closest('.has-subMenu-left');
      if (!megaMenu) {
        active.closest('ul').previousSibling.classList.add('active');
        if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
      } else {
        active.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
      }
    };
    window.addEventListener('load', active && activeDefault);
    return () => window.removeEventListener('load', activeDefault);
  }, []);

  const addParentActive = event => {
    document.querySelectorAll('.parent').forEach(element => {
      element.classList.remove('active');
    });

    const hasSubMenuLeft = event.currentTarget.closest('.has-subMenu-left');
    const megaMenu = event.currentTarget.closest('.megaMenu-wrapper');
    if (!megaMenu) {
      event.currentTarget.closest('ul').previousSibling.classList.add('active');
      if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
    } else {
      event.currentTarget.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
    }
  };
  return (
    <TopMenuStyle>
      <div className="strikingDash-top-menu">
        <ul>
          <li>
            <Link 
              to={`${path}/`} 
              className="parent"
              style={
                {color: `${(window.location.pathname === '/admin/') ? '#EC1C24' : '#5A5F7D'}`}
              }
            >
              <FeatherIcon icon="home" />
              <span style={{marginLeft: '4px'}}>Home</span>
            </Link>
          </li>

          <li>
            <Link 
              style={
                {color: `${(window.location.pathname === '/admin/shoutout') ? '#EC1C24' : '#5A5F7D'}`}
              } 
              to={`${path}/shoutout`} 
              className="parent"
            >
              <FeatherIcon icon="mic" />
              <span style={{marginRight: '4px'}}>Shout Out</span>
            </Link>
          </li>

          <li>
            <Link 
              style={
                {color: `${(window.location.pathname === '/admin/shop') ? '#EC1C24' : '#5A5F7D'}`}
              } 
              to={`${path}/shop`} 
              className="parent"
            >
              <FeatherIcon icon="shopping-cart" />
              <span style={{marginRight: '4px'}}>Shop</span>
            </Link>
          </li>

        </ul>
      </div>
    </TopMenuStyle>
  );
};

export default TopMenu;
